// extracted by mini-css-extract-plugin
export var container = "l6SmWPRN";
export var primary = "_2cX1EjVA";
export var title = "JBe0KEX-";
export var secondary = "QbAIhtCd";
export var titleContainer = "LQFPycvS";
export var secondaryAlt = "_69EuKrLV";
export var titleIconContainer = "_4DdDrqgv";
export var tertiary = "wnxFdqRQ";